export const en = {
  consent: {
    title: 'We value your privacy',
    description:
      'We use cookies and similar technologies to run this site, understand how it is used, and support our marketing. You can accept all, reject non-essential ones, or choose which to allow. You can change your choice at any time.',
    acceptAll: 'Accept all',
    rejectAll: 'Reject all',
    managePreferences: 'Manage preferences',
    savePreferences: 'Save preferences',
    preferencesTitle: 'Cookie preferences',
    preferencesDescription:
      'Choose which categories you allow. Strictly necessary cookies are always on because the site cannot work without them.',
    alwaysOn: 'Always on',
    categories: {
      necessary: {
        title: 'Strictly necessary',
        description:
          'Required for the site to function, including signing in and keeping your session secure. These cannot be turned off.',
      },
      analytics: {
        title: 'Analytics',
        description:
          'Help us understand how visitors use the site so we can improve it.',
      },
      marketing: {
        title: 'Marketing',
        description:
          'Let us measure our campaigns and understand which visitors are interested in Purposely.',
      },
    },
  },
}
